'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _quickDepositComponents = require('@wh/quick-deposit-components');

var _selectors = require('../../selectors');

var _actions = require('../../actions');

/**
 * Maps the state to properties
 *
 * @param {StateType} state The state map
 * @param {Object} props the props object
 * @returns {Object} The properties to be passed to the 3ds panel component
 */
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    securePaymentData: (0, _selectors.securePaymentDataSelector)(state, props),
    trackingData: (0, _selectors.trackingDataSelector)(state, props),
    activeDepositData: (0, _selectors.activeDepositDataSelector)(state, props)
  };
};

var mapDispatchToProps = {
  complete3DS: _actions.complete3DS,
  trackEvent: _actions.trackEvent
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_quickDepositComponents.SecurePaymentPanelComponent);